import PropTypes from 'prop-types';

function InstructionsInput(props) {
  const { handleInstructionsInput } = props;

  return (
    <div>
      <label>User Input Guidance</label>
      <input id="#instructions" className="form-control" onChange={handleInstructionsInput} />
      <i>
        This text will display guidance on how to fill in this info field. The user will see this text when hovering
        over the info field on Upload and Edit Asset Info.
      </i>
      <hr />
    </div>
  );
}

InstructionsInput.propTypes = {
  handleInstructionsInput: PropTypes.func,
};

export default InstructionsInput;
